module.exports = __webpack_public_path__ + "img/modal-backarrow.eb36b296.svg";